module.exports = __webpack_public_path__ + "static/24-daefc0960f4fda3715e8fa0eac90f9e8.png";